import React from "react";
import Typography from "@mui/joy/Typography";
import {Stack} from "@mui/joy";


class WebinarDetailHeader extends React.Component {
    render() {
        return(
            <Stack>
                <Typography level={'h4'}>
                    {this.props.webinar.title}
                </Typography>
            </Stack>
        )
    }
}

export default WebinarDetailHeader